// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".activity-board-column {\n  -webkit-box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.1) !important;\n  overflow-y: auto;\n}[dir] .activity-board-column {\n  background-color: #e9ecef;\n          box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.1) !important;\n}\n.activity-board-column > div,\n.activity-board-column > div > div {\n  position: relative;\n  height: 100%;\n}", ""]);
// Exports
module.exports = exports;
